<template>
  <panel-main-template>
    <template v-slot:page-title>
      Журнал записей
      <hints
          :title="'Узнай как работать с данным разделом за несколько минут'"
          :type="'youtube'"
          :url="getYotubeLink('journal')"
      ></hints>
    </template>
    <template v-slot:page-info>
      <div class="journal--page-info-flex">
        <div><span class="status-new"></span> Новые записи</div>
        <div>
          <span class="status-confirm"></span> Подтвержденные записи
        </div>
        <div>
          <span class="status-done"></span> Выполненные записи
        </div>
        <div>
          <span class="status-canceled"></span> Отмененные записи
        </div>
      </div>
    </template>
    <template v-slot:page-content>
      <div class="journal--content">
        <div v-if="supportMessageCount > 0" class="alert alert-sm alert-success mrg-b-10">
          У вас имеются непрочитанные сообщения от службы поддержки
          <router-link tag="div" class="btn btn-sm btn-outline-info" :to="`/support/`">
            <div>
              Перейти
            </div>
          </router-link>
        </div>
        <div v-if="noData" class="alert alert-danger">
          Для работоспособности сервиса, вам необходимо последовательно создать:<br><br>
          - Компанию (Раздел "Компании/Филиалы")<br>
          - Услугу(-и) (Раздел "Услуги")<br>
          - Сотрудника(-ов) (Раздел "Сотрудники")<br>
          - Задать расписание сотрудникам (Раздел "Расписание") <br><br>
          Кликните на
          <hints
              :title="'Первоначальная настройка сервиса'"
              :url="getYotubeLink('firstSetting')"
              type="youtube"
          ></hints>,
          чтобы посмотреть короткое видео о первоначальной настройке
        </div>
        <div v-if="!noData" class="journal--actions-container">
          <div class="left">
            <div v-if="journalSetting.showBalance && checkPermission('user')" class="balance shadow-card-sm">
              <balance></balance>
            </div>
            <div v-if="journalSetting.showProfit && checkPermission('user')" class="profit shadow-card-sm">
              <profit-widget></profit-widget>
            </div>
          </div>
          <div class="right">
            <div>
              <div v-if="checkPermission('user')" @click="showJournalSettingPopup" class="btn btn-sm btn-outline-info mrg-t-10">
                <f-awesome icon="cog"></f-awesome>
              </div>
              <div @click="showMagicPopup" class="btn btn-sm btn-outline-info mrg-t-10">
                <f-awesome icon="magic"></f-awesome>
              </div>
              <div @click="printLabels" class="btn btn-sm btn-outline-info mrg-t-10">
                <f-awesome icon="print"></f-awesome>
              </div>
              <div @click="searchEnroll" class="btn btn-sm btn-outline-info mrg-t-10">
                <f-awesome icon="search"></f-awesome> Поиск записи
              </div>
              <div
                v-if="checkPermission('create_enroll')"
                @click="newEnroll"
                class="btn btn-sm btn-info mrg-t-10"
              >
                <f-awesome icon="plus"></f-awesome> Создать запись
              </div>
            </div>
          </div>
        </div>
        <journal-month
          @selectJournalMode="selectMode"
          :modeJournalList="modeList"
          :modeJournalActive="mode"
          :staff="staffList"
          v-if="mode === 'month'"
        ></journal-month>
        <journal-week
          @selectJournalMode="selectMode"
          :modeJournalList="modeList"
          :modeJournalActive="mode"
          :staff="staffList"
          v-if="mode === 'week'"
        ></journal-week>
        <journal-day
          @selectJournalMode="selectMode"
          :modeJournalList="modeList"
          :modeJournalActive="mode"
          :staff="staffList"
          v-if="mode === 'day'"
        ></journal-day>
      </div>

      <popup
        :closeButton="newEnrollPopup.closeButton"
        :show="newEnrollPopup.show"
        :size="newEnrollPopup.size"
        :backgroundColor="newEnrollPopup.backgroundColor"
        @closePopup="closeNewEnrollPopup"
      >
        <div slot="header">Добавление записи</div>
        <div slot="body">
          <new-enroll
            @closeAndUpdate="closeNewEnrollAndUpdate"
            :reset="newEnrollComponent.reset"
          ></new-enroll>
        </div>
      </popup>

      <popup
          :closeButton="searchEnrollPopup.closeButton"
          :show="searchEnrollPopup.show"
          :size="searchEnrollPopup.size"
          @closePopup="closeSearchEnrollPopup"
      >
        <div slot="header">Поиск записи</div>
        <div slot="body">
          <search-enroll :reset="!searchEnrollPopup.show"></search-enroll>
        </div>
      </popup>

      <popup
          :closeButton="printLabelsPopup.closeButton"
          :show="printLabelsPopup.show"
          @closePopup="closePrintLabelsPopup"
      >
        <div slot="header">Выгрузка списка записей в файл .docx</div>
        <div slot="body">
          <print-labels :staff_list="staffList" :show="printLabelsPopup.show"></print-labels>
        </div>
      </popup>

      <popup
          :closeButton="magicPopup.closeButton"
          :show="magicPopup.show"
          @closePopup="closeMagicPopup"
      >
        <div slot="header">Полезные функции журнала записей</div>
        <div slot="body">
          <div class="text-center">
            <div class="hr-short"><div></div></div>
            <auto-done-enrolls
              class="mrg-t-15"
            ></auto-done-enrolls>
            <div class="text-center text-small mrg-t-15">
              При нажатии данной кнопки, все записи до вчерашнего дня,
              будут переведены в статус "Выполнено". (Кроме отмененных. Они так и останутся отмененными).<br>
              Функция может быть полезна, если вы забываете завершать записи, но при этом хотите, чтобы
              статистика в разделе "Отчеты" показывала информацию более точно (т.к многие пункты
              считаются на основе записей в статусе "Выполнено").
            </div>
            <div class="hr-short mrg-t-15"><div></div></div>
          </div>
        </div>
      </popup>


      <popup
          :closeButton="journalSettingPopup.closeButton"
          :show="journalSettingPopup.show"
          @closePopup="closeJournalSettingPopup"
      >
        <div slot="header">Настройки журнала записей</div>
        <div slot="body">
          <div class="">
            <toggle-button
              v-model="journalSetting.showBalance"
              :mode="'bool'"
              :text="'Отображать пакетный остаток на счете в журнале записей'"
            ></toggle-button>
          </div>
          <div class="mrg-t-20">
            <toggle-button
              v-model="journalSetting.showProfit"
              :mode="'bool'"
              :text="'Отображать статистику дохода за предыдущий и текущий месяц в журнале записей'"
            ></toggle-button>
          </div>

        </div>
      </popup>


    </template>
  </panel-main-template>
</template>

<script>
// @ is an alias to /src

import { mapState } from "vuex";
import PanelMainTemplate from "../../components/panel/MainTemplate";
import JournalMonth from "../../components/panel/journal/JournalMonth";
import JournalWeek from "../../components/panel/journal/JournalWeek";
import JournalDay from "../../components/panel/journal/JournalDay";
import Popup from "../../components/Popup";
import NewEnroll from "../../components/panel/journal/new/NewEnroll";
import SearchEnroll from "@/components/panel/journal/SearchEnroll";
import Hints from "@/components/Hints";
import permissionMixin from "@/components/mixins/Permissions";
import youtubeMixin from "@/components/mixins/Youtube";
import PrintLabels from "@/components/panel/journal/PrintLabels";
import AutoDoneEnrolls from '../../components/panel/journal/AutoDoneEnrolls.vue';
import Balance from '../../components/Balance.vue';
import ProfitWidget from '../../components/panel/journal/ProfitWidget.vue';
import ToggleButton from '../../components/ui_elements/ToggleButton.vue';
import staffRepository from "../../repositories/staff";


// const permissions = new Permissions();

export default {
  name: "Journal",
  components: {
    PrintLabels,
    Hints,
    SearchEnroll,
    NewEnroll,
    Popup,
    JournalDay,
    JournalWeek,
    JournalMonth,
    PanelMainTemplate,
    AutoDoneEnrolls,
    Balance,
    ProfitWidget,
    ToggleButton
  },
  mixins: [permissionMixin, youtubeMixin],
  data() {
    return {
      showUpdate: false,
      mode: "",
      modeList: [
        {
          name: "Месяц",
          val: "month"
        },
        {
          name: "Неделя",
          val: "week"
        },
        {
          name: "День",
          val: "day"
        }
      ],
      staffList: [],
      newEnrollPopup: {
        show: false,
        // closeButton: 'Отмена',
        size: "lg",
        backgroundColor: 'wgray'
      },
      searchEnrollPopup: {
        show: false,
        closeButton: 'Отмена',
      },
      printLabelsPopup: {
        show: false,
        closeButton: 'Отмена',
      },
      magicPopup: {
        show: false,
        closeButton: 'Закрыть',
      },
      journalSettingPopup: {
        show: false,
        closeButton: 'Закрыть',
      },
      journalSetting: {
        showBalance: false,
        showProfit: false
      },
      newEnrollComponent: {
        reset: 0
      },
      noData: false
    };
  },
  metaInfo: {
    title: "Журнал записей - Enroller",
    meta: [
      {
        name: 'viewport',
        content: "width=device-width, initial-scale=1, minimum-scale=1, user-scalable=no"
      }
    ]
  },
  watch: {
    journalSetting: {
      handler(val) {
        localStorage.setItem('journal_setting_show_balance', val.showBalance === true ? 'true' : 'false');
        localStorage.setItem('journal_setting_show_profit', val.showProfit === true ? 'true' : 'false');
      },
      deep: true
    },
  },
  computed: {
    ...mapState({
      supportMessageCount: state => state.support.messageCount,
    }),
  },
  methods: {
    showJournalSettingPopup(){
      this.journalSettingPopup.show = true;
    },
    closeJournalSettingPopup(){
      this.journalSettingPopup.show = false;
    },
    closeMagicPopup(){
      this.magicPopup.show = false;
    },
    showMagicPopup(){
      this.magicPopup.show = true;
    },
    printLabels(){
      this.printLabelsPopup.show = true;
    },
    closePrintLabelsPopup(){
      this.printLabelsPopup.show = false;
    },
    closeNewEnrollPopup() {
      this.newEnrollPopup.show = false;
      setTimeout(() => {
        this.newEnrollComponent.reset = this.newEnrollComponent.reset + 1;
      }, 700);
    },
    closeNewEnrollAndUpdate() {
      this.newEnrollPopup.show = false;
      setTimeout(() => {
        this.newEnrollComponent.reset = this.newEnrollComponent.reset + 1;
      }, 700);
    },
    newEnroll() {
      this.newEnrollPopup.show = true;
      this.$store.dispatch("addYaMetricTarget", {targetName: 'CLICK_NEW_ENROLL'});
    },
    selectMode(val) {
      this.mode = val;
      localStorage.setItem('journal_mode', val);
    },
    searchEnroll() {
      this.searchEnrollPopup.show = true;
    },
    closeSearchEnrollPopup(){
      this.searchEnrollPopup.show = false;
    }
  },
  created() {
    staffRepository.getStaff().then(resp => {
      if(!resp.data.length){
        this.noData = true;
      }else{
        this.staffList = resp.data;
      }
    }).catch(err => {
      this.$store.dispatch("addNotification", {
        text: err.response.data.message,
        time: 6,
        color: "danger"
      });
    })

    let modeStorage = localStorage.getItem('journal_mode');
    if(modeStorage === null){
      localStorage.setItem('journal_mode', 'month');
      this.selectMode('month');
    }else{
      this.selectMode(modeStorage);
    }

    let journalSetShowBalance = localStorage.getItem('journal_setting_show_balance');
    if(journalSetShowBalance === null){
      localStorage.setItem('journal_setting_show_balance', 'true');
      this.journalSetting.showBalance = true;
    }else{
      this.journalSetting.showBalance = journalSetShowBalance == 'true' ? true : false;
    }

    let journalSetShowProfit = localStorage.getItem('journal_setting_show_profit');
    if(journalSetShowProfit === null){
      localStorage.setItem('journal_setting_show_profit', 'true');
      this.journalSetting.showProfit = true;
    }else{
      this.journalSetting.showProfit = journalSetShowProfit == 'true' ? true : false;
    }

  }
};
</script>

<style scoped lang="less">
.journal--actions-container {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  flex-direction: row;
  margin-bottom: 28px;

  & .left{
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;
    flex-direction: row;
    width: 50%;

    .balance{
      font-size: 13px;
    }
    .profit{
      margin-left: 10px;
      font-size: 13px;
    }
  }
  & .right{
    text-align: right;
    width: 50%;
  }
}
.journal--page-info-flex {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-end;
  flex-direction: row;
  font-size: 14px;
  font-weight: 700;
  color: #4f4f4f;

  & > div {
    margin-right: 15px;

    span {
      display: inline-block;
      width: 14px;
      height: 14px;
      border-radius: 12px;
    }
  }
}

@media (max-width: 800px) {
  .journal--actions-container {
    flex-wrap: wrap;
    justify-content: space-around;
    // margin-bottom: 28px;

    & .left{
      flex-wrap: wrap;
      justify-content: flex-start;
      width: 100%;
    }
    & .right{
      width: 100%;
      margin-top: 10px;
    }
  }
}

@media (max-width: 700px) {
  .journal--page-info-flex {
    flex-wrap: wrap;
    justify-content: flex-start;
    flex-direction: row;
  }
}
@media (max-width: 550px) {
  .journal--actions-container {
    flex-wrap: wrap;
    justify-content: space-around;
    // margin-bottom: 28px;

    & .left{
      flex-wrap: wrap;
      justify-content: flex-start;
      width: 100%;

      &>.balance{
        margin-bottom: 10px;
      }

      &>.profit{
        margin-bottom: 10px;
        margin-left: 0;
      }
    }
    & .right{
      width: 100%;
      margin-top: 10px;
    }
  }
}
</style>
